import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DramasPage from "../pages/dramas/page";
import DramaDetailPage from "../pages/drama/page";
import CastPage from "../pages/cast/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/newsDetail/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dramas",
    element: <DramasPage />,
  },
  {
    path: "/drama/:id",
    element: <DramaDetailPage />,
  },
  {
    path: "/cast",
    element: <CastPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;